import React, {useState} from 'react';
import {Button, Divider, Typography} from '@material-ui/core';

import TabularList from './DependentsTabularList';
import './Dependents.sass';
import DependentMaintenanceDialog from './DependentMaintenanceDialog';
import {Dependents} from 'ApplicationEntry/models/Dependents';
import {InvalidApplication, ValidApplication} from 'ApplicationEntry/models/Application';
import {MAX_DEPENDENTS} from 'ApplicationEntry/models/DependentLists';

type DependentsProps = {
  dependents: Dependents;
  application: InvalidApplication | ValidApplication;
  isQuality: boolean;
};

export default function DependentsDashboard(props: DependentsProps) {
  const {application} = props;
  const selectedPolicyList =
    application.caseDetails.productType.key == 'LoadedPolicyTypes'
      ? application.caseDetails.productType.selectedPolicyTypes
      : [];

  const [dialogOpen, setDialogueOpen] = useState(false);

  const handleClickOpen = () => {
    setDialogueOpen(true);
  };

  const handleClose = () => {
    setDialogueOpen(false);
  };

  return (
    <div className="dependents-section" id="dependent-dashboard">
      <div className="dependents-section__main-header">
        <Typography variant="subtitle1" className="dependents-section__head" color="primary">
          Dependents List
        </Typography>

        {application.dependentLists.dependentList.size < MAX_DEPENDENTS ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleClickOpen}
            className="dependents-section__main-header-button"
          >
            ADD DEPENDENT
          </Button>
        ) : null}
      </div>
      {application.dependentLists.dependentList.size < 1 ? (
        <>
          <div className="dependents-section__no-item" id="dependent-dashboard_no-item">
            <div className="dependents-section__box">
              <div className="dependents-section__image" />

              <h3 className="dependents-section__title">No Associated Dependent</h3>
              <Typography className="dependents-section__content" variant="body2" color="initial">
                Click the "Add Dependent" button above to add a dependent
              </Typography>
            </div>
          </div>
        </>
      ) : (
        <TabularList
          DependentItems={application.dependentLists}
          selectedPolicyList={selectedPolicyList}
          isQuality={props.isQuality}
        />
      )}
      <DependentMaintenanceDialog
        dialogOpen={dialogOpen}
        dialogClose={handleClose}
        dialogTitle="Add Dependent(s)"
        dialogSubTitle="Dependent(s) Information"
        dialogAdditional="ADDITIONAL DEPENDENT"
        dependentIndex={0}
        editDependent={false}
      />
      <Divider className="application-form__actions-divider" />
    </div>
  );
}
